import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { clearUserLogged, logoutAction, setSessionExpired, switchIdpAccount } from 'features/common/commonSlice';

export interface FiltersState {
  filtersSelected: {
    dashboard?: any;
    activity?: any;
    events?: any;
    /** Actividad por expedientes (vista general y ficha): filtros aparte de los de eventos. */
    dashboardExpedients?: any;
    eventsExpedients?: any;
    devices?: any;
    users?: any;
    relatives?: any;
    warehouses?: any;
    professionals?: any;
    groups?: any;
    agendas?: any;
    deviceActivity?: any;
    reset?: any;
  }
  pathId: any;
  // Flag para la actividad de la ficha de dispositivo: indica si el dispositivo es periférico,
  // para que FilterSection lance el thunk de búsqueda correcto.
  deviceActivityIsPeripheral: boolean;
  showFilters: boolean;
}

const initialState: FiltersState = {
  filtersSelected: {
    dashboard: {},
    activity: {},
    events: {},
    dashboardExpedients: {},
    eventsExpedients: {},
    devices: {},
    users: {},
    relatives: {},
    warehouses: {},
    professionals: {},
    groups: {},
    agendas: {},
    deviceActivity: {},
    reset: {},
  },
  pathId: null,
  deviceActivityIsPeripheral: false,
  showFilters: false,
}

export const filtersSlice = createSlice({
  name: 'filters',
  initialState,
  reducers: {
    setShowFilters: (state, action: PayloadAction<boolean>) => {
      state.showFilters = action.payload;
    },
    setFiltersSelected: (state, action: PayloadAction<{ propName: any, filtersValue: any }>) => {
      state.filtersSelected = {
        ...state.filtersSelected,
        [action.payload.propName]: action.payload?.filtersValue
      };
    },
    setPathId: (state, action: PayloadAction<any>) => {
      // Los filtros de la actividad de la ficha (paciente o dispositivo) son de ESA ficha:
      // al cambiar de paciente/dispositivo no deben arrastrarse al siguiente.
      if (state.pathId !== action.payload) {
        state.filtersSelected.events = {};
        state.filtersSelected.eventsExpedients = {};
        state.filtersSelected.deviceActivity = {};
      }
      state.pathId = action.payload;
    },
    setDeviceActivityPeripheral: (state, action: PayloadAction<boolean>) => {
      state.deviceActivityIsPeripheral = action.payload;
    },
    resetFiltersSelected: () => initialState,
  },
  extraReducers: (builder) => {
    // Los filtros viven en memoria y el logout no recarga la página: sin esto, el siguiente
    // login en la misma pestaña (sea o no el mismo usuario) encuentra los filtros anteriores.
    builder
      .addCase(logoutAction, () => initialState)
      .addCase(clearUserLogged, () => initialState)
      .addCase(setSessionExpired, () => initialState)
      .addCase(switchIdpAccount, () => initialState);
  },
});

export const { setShowFilters, setFiltersSelected, resetFiltersSelected, setPathId, setDeviceActivityPeripheral } = filtersSlice.actions;

export default filtersSlice.reducer;
